import { api } from './client';

export interface NotificationDto {
  id: string;
  tick: number;
  category: string;
  summary: string;
  readAt: string | null;
  createdAt: string;
}

export interface UnreadCountResponse {
  count: number;
}

export interface MarkReadRequest {
  notificationIds?: string[];
  beforeTick?: number;
}

export interface MarkReadResponse {
  markedCount: number;
}

export async function getNotifications(
  worldId: string,
  provinceId: string,
  params: { before?: number; limit?: number } = {}
) {
  const query = new URLSearchParams();
  if (params.before != null) query.set('before', String(params.before));
  if (params.limit != null) query.set('limit', String(params.limit));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return api.get<NotificationDto[]>(
    `/api/worlds/${worldId}/provinces/${provinceId}/notifications${qs}`
  );
}

export async function getUnreadCount(worldId: string, provinceId: string) {
  return api.get<UnreadCountResponse>(
    `/api/worlds/${worldId}/provinces/${provinceId}/notifications/unread-count`
  );
}

export async function markRead(
  worldId: string,
  provinceId: string,
  request: MarkReadRequest
) {
  return api.post<MarkReadResponse>(
    `/api/worlds/${worldId}/provinces/${provinceId}/notifications/mark-read`,
    request
  );
}
